<mat-accordion class="w-100">
    <!-- expansion panel Container start-->
    <ng-container *ngFor="let notification of notificationList">
    <mat-expansion-panel [expanded]="expandPanel" (opened)="panelOpenState = true"
      (closed)="panelOpenState = false" *ngIf="notification?.uploadCount > 0">
       <mat-expansion-panel-header class="d-flex" style="flex-direction: row-reverse;padding: 0px 0px 0px 8px;"> 
        <mat-panel-title class="ml-2">
          <span class="pendingTagTotal mr-1" >{{notification.uploadCount}}</span>
          <span class="panel-notification-header pl-1">{{notification.supplierName + ' ' + notification.organizationCode}}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <!-- Pannel Body start-->
      <ng-container *ngIf="notification.documentTypes !== null">
      <div class="row pl-4 mx-0 pendingTag" *ngFor="let selectedDoc of notification.documentTypes.selectedDocumentTypes">
        <!-- Pannel Body content start-->
        <div class="col-10 p-0" *ngIf="selectedDoc.upload !=0 ">
          <div class="row mx-0">
            <div class=" mr-2 col-1 p-0">
              <div class="pendingTagTotal pointer-cursor" (click)="saveSelectedFolder(notification.organizationCode, selectedDoc)">{{selectedDoc.upload}}</div>
            </div>
            <div class="col-10 p-0 panel-notification-content">{{selectedDoc.documentType}}</div>
          </div>
        </div>
        <div class="col-1" *ngIf="selectedDoc.upload !=0 ">
          <i class="material-icons panel-notification-content circle-outline"
            matTooltip="Click to dismiss notification" 
           (click)="dismissNotification(usersInfo.cwsId,notification.supplierId,selectedDoc.documentType)">check_circle_outline</i>
        </div>
      </div>
    </ng-container>
      <!-- Pannel Body end-->
    </mat-expansion-panel>
    </ng-container>
    <!-- expansion panel Container end-->

  </mat-accordion>

  <div class="sg-no-notifications" *ngIf="!hasPendingNotifications">
    <ng-container *ngIf="hasSubscriptions">No new notifications, you're all caught up.</ng-container>
    <ng-container *ngIf="!hasSubscriptions">Click Manage below to subscribe to supplier notifications.</ng-container>
  </div>